module.exports = __webpack_public_path__ + "media/images/city_img/r_3-6f4c29f9ed2e67f729de14a77b60aa30.png";